/** Impressoras ativas (ausência do campo conta como ativa). */
export function filterActivePrinters(printers) {
    return (printers || []).filter((printer) => printer?.active !== false);
}

const printerNameCollator = new Intl.Collator('pt-BR', {
    sensitivity: 'base',
    numeric: true,
});

export function sortPrintersByName(printers) {
    return [...(printers || [])].sort((a, b) => (
        printerNameCollator.compare(a?.name || '', b?.name || '')
    ));
}

/** Ordem de cadastro: mais antiga primeiro (estável, não varia com métricas). */
export function sortPrintersByRegistrationOrder(printers) {
    const list = [...(printers || [])];
    if (list.length <= 1) {
        return list;
    }

    const hasCreatedAt = list.some((printer) => printer?.created_at);
    if (hasCreatedAt) {
        return list.sort((a, b) => {
            const aTime = Date.parse(a.created_at) || 0;
            const bTime = Date.parse(b.created_at) || 0;
            if (aTime !== bTime) {
                return aTime - bTime;
            }
            return printerNameCollator.compare(a?.name || '', b?.name || '');
        });
    }

    // API lista por created_at DESC; inverter = ordem de cadastro crescente.
    return list.reverse();
}
